import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { deleteEconomicsApi, fetchPriceDecksApi, fetchUserEconomicsApi, loadEconomicsAPI, saveEconomicsApi } from '../api/economicsAPI';

export const getEconomics = createAsyncThunk(
  'economics/getEconomics',
  async (email, { rejectWithValue }) => {
    try {
      const userEconomics = await fetchUserEconomicsApi(email);
      // const priceDecks = await fetchPriceDecksApi();
      return { economics: userEconomics };
      // return { economics: userEconomics, priceDecks: priceDecks };
    } catch (error) {
      return rejectWithValue(email);
    };
  }
);

export const addEconomics = createAsyncThunk(
  'economics/addEconomics',
  async (payload, { rejectWithValue }) => {
    try {
      return { economics: payload.economics, projectId: payload.projectId };
    } catch (error) {
      return rejectWithValue(payload);
    };
  }
);

export const updateEconomics = createAsyncThunk(
  'economics/updateEconomics',
  async (payload) => {
    try {
      return {...payload.economics};
    } catch (error) {
      return null;
    };
  }
);

export const saveEconomics = createAsyncThunk(
  'economics/saveEconomics',
  async (economics) => {
    try {
      await saveEconomicsApi(economics);
      return economics;
    } catch (error) {
      return null;
    };
  }
);

export const deleteEconomics = createAsyncThunk(
  'economics/deleteEconomics',
  async (economicsId) => {
    try {
      await deleteEconomicsApi(economicsId);
      return economicsId;
    } catch (error) {
      return null;
    };
  }
);

export const loadEconomics = createAsyncThunk(
  'economics/loadEconomics',
  async (payload, { rejectWithValue }) => {
    try {
      const economicsLocation = payload.location;
      const economicsId = payload.economicsId;
      const userEmail = payload.email;
      if (economicsLocation && economicsId && userEmail) {
        const result = await loadEconomicsAPI(economicsLocation, economicsId, userEmail);
        return {...result, public: false, createdBy: userEmail};
      };
    } catch (error) {
      return rejectWithValue(payload?.id);
    };
  }
);

export const fetchCommodityPrices = createAsyncThunk(
  'economics/fetchCommodityPrices',
  async () => {
    try {
      const priceDecks = await fetchPriceDecksApi();
      return priceDecks;
    } catch (error) {
      return null;
    };
  }
);


const initialState = {
  byId: {},
  allIds: [],
  currentEconomicsId: '',
  prices: null
};

export const economicsSlice = createSlice({
  name: 'economics',
  initialState,
  reducers: {
    updateCurrentEconomics: (state, action) => {
      const id = action.payload.id;
      state.currentEconomicsId = id;
    },
    newPriceDeck: (state, action) => {
      const name = action.payload;
      state.prices[name] = [];
    },
    setCurrentPriceDeck: (state, action) => {
      const name = action.payload.priceDeckName;
      const economicsId = action.payload.economicsId;
      state.byId[economicsId].settings.priceDeckName = name;
    },
    updateEconomicsSettings: (state, action) => {
      try {
        const economicsId = action.payload.economicsId;
        state.byId[economicsId].settings = action.payload.economicsSettings;
      } catch (error) {
        return;
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getEconomics.fulfilled, (state, action) => {
      try {
        const userEconomics = action.payload?.economics;
        // const priceDecks = action.payload?.priceDecks;

        if (!userEconomics) return;

        // if (!state.prices) {
        //   state.prices = {};
        // };

        // for (let priceDeckName of Object.keys(priceDecks)) {
        //   state.prices[priceDeckName] = priceDecks[priceDeckName];
        // };

        if (userEconomics.length > 0) {
          for (let i = 0; i < userEconomics.length; i++) {
            const id = userEconomics[i].id;
            state.byId[id] = userEconomics[i];
            state.byId[id].lastSavedSettings = userEconomics[i]?.settings;
            if (state.allIds.indexOf(id) === -1) state.allIds.push(id);
          };
        };
        
        state.currentEconomicsId = userEconomics?.slice(-1)?.[0].id;
      } catch (error) {
        return;
      };
    })
    // builder.addCase(getPriceDecks.fulfilled, (state, action) => {
    //   try {
    //     const priceDecks = action.payload;
    //     if (!priceDecks) return;

    //     if (!state.prices) {
    //       state.prices = {};
    //     };
    //     for (let priceDeckName of Object.keys(priceDecks)) {
    //       state.prices[priceDeckName] = priceDecks[priceDeckName];
    //     };

    //   } catch (error) {
    //     return;
    //   };
    // })
    builder.addCase(addEconomics.fulfilled, (state, action) => {
      try {
        const economics = action.payload.economics;
        if (!economics) return;
        const id = economics.id;
        state.byId[id] = economics;
        if (state.allIds.indexOf(id) === -1) state.allIds.push(id);
        state.currentEconomicsId = id;
      } catch (error) {
        return;
      };
    })
    builder.addCase(updateEconomics.fulfilled, (state, action) => {
      try {
        const id = action.payload.id;
        const lastSavedSettings = state.byId?.[id]?.lastSavedSettings;
        state.byId[id] = action.payload;
        state.byId[id].lastSavedSettings = lastSavedSettings || action.payload.lastSavedSettings;;
        if (state.allIds.indexOf(id) === -1) state.allIds.push(id);
        state.currentEconomicsId = id;
      } catch (error) {
        return;
      };
    })
    builder.addCase(deleteEconomics.fulfilled, (state, action) => {
      try {
        const id = action.payload;
        delete state.byId[id];
        state.allIds = state.allIds.filter((economicsId) => economicsId !== id);
        if (state.currentEconomicsId === id) state.currentEconomicsId = state.allIds[0] || '';
      } catch (error) {
        return;
      };
    })
    builder.addCase(saveEconomics.fulfilled, (state, action) => {
      if (action.payload) {
        const economics = action.payload;
        state.byId[economics.id] = {...economics, lastSavedSettings: economics.settings};
      };
    })
    builder.addCase(loadEconomics.fulfilled, (state, action) => {
      try {
        if (action.payload) {
          let economics = {...action.payload};
          if (!economics?.settings?.priceDeckName?.length > 0 && state.prices) {
            economics.settings.priceDeckName = Object.keys(state.prices)?.[0];
            economics.settings.priceOil = [];
            economics.settings.priceGas = [];
            economics.settings.priceCondensate = [];
          };
          
          if (!economics.settings.discountRate) economics.settings.discountRate = 0.05;
          if (!economics.settings.abandonmentDelay) economics.settings.abandonmentDelay = 60;
          if (!economics.settings.ownershipCapex) economics.settings.ownershipCapex = 1;

          state.byId[economics.id] = economics;
          
          state.byId[economics?.id].lastSavedSettings = economics?.settings;
  
          if (state.allIds.indexOf(economics.id) === -1) {
            state.allIds.push(economics.id);
          };
          state.currentEconomicsId = economics.id;
        };
      } catch (error) {
        return;
      };
    })
    builder.addCase(fetchCommodityPrices.fulfilled, (state, action) => {
      try {
        
        const priceDecks = action.payload;

        if (!state.prices) {
          state.prices = {};
        };

        for (let priceDeckName of Object.keys(priceDecks)) {
          state.prices[priceDeckName] = priceDecks[priceDeckName];
        };
        // state.prices.usd = action.payload.usd;
        // state.prices.cad = action.payload.cad;
      } catch (error) {
        return;
      };
    })
  },
});

export const { updateCurrentEconomics, newPriceDeck, setCurrentPriceDeck, updateEconomicsSettings } = economicsSlice.actions;

export const selectEconomics = (state) => state.economics;

export default economicsSlice.reducer;
